<template>
	<div class="pt-10 pb-5 pb-sm-8 text--h1 font-weight-bold">
		<h1
			class="px-5 main--title font-weight-bold mt-sm-10 text-left text-sm-center mb-5 mb-sm-12 pb-sm-1 white-space-pre"
		>
			{{ $t('review.title') }}
		</h1>

		<div
			class="mx-auto"
			style="position: relative"
			:style="
				userDevice === 'desktop'
					? 'max-width: 1200px;width:100%;min-width:1110px;'
					: ''
			"
		>
			<swiper class="swiper" :options="swiperOption">
				<swiperSlide v-for="review in reviews" :key="review.name">
					<ReviewCard
						:name="review.name"
						:job="review.job"
						:comment="review.comment"
						:profile="review.profile"
					/>
				</swiperSlide>
			</swiper>
			<!-- <v-slide-group v-model="slide" show-arrow center-active>
				<v-slide-item v-for="(review, index) in reviews" :key="review.name">
					<ReviewCard
						class="mx-1"
						:name="review.name"
						:job="review.job"
						:comment="review.comment"
						@click="slide = index"
					/>
				</v-slide-item>
			</v-slide-group> -->
			<div class="gradient left d-none d-sm-block"></div>
			<div class="gradient right d-none d-sm-block"></div>
		</div>
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ReviewCard from './ReviewCard'

export default {
	components: {
		ReviewCard,
		swiper,
		swiperSlide,
	},

	data() {
		return {
			slide: 0,
			reviews: [
				{
					comment: this.$t('review.review1.comment'),
					name: this.$t('review.review1.name'),
					job: this.$t('review.review1.job'),
					profile: 'park',
				},

				{
					comment: this.$t('review.review2.comment'),
					name: this.$t('review.review2.name'),
					job: this.$t('review.review2.job'),
					profile: 'hannah',
				},

				{
					comment: this.$t('review.review3.comment'),
					name: this.$t('review.review3.name'),
					job: this.$t('review.review3.job'),
					profile: 'euna',
				},
				{
					comment: this.$t('review.review4.comment'),
					name: this.$t('review.review4.name'),
					job: this.$t('review.review4.job'),
					profile: 'jin',
				},
				{
					comment: this.$t('review.review5.comment'),
					name: this.$t('review.review5.name'),
					job: this.$t('review.review5.job'),
					profile: 'lee',
				},
				{
					comment: this.$t('review.review6.comment'),
					name: this.$t('review.review6.name'),
					job: this.$t('review.review6.job'),
					profile: 'kim',
				},
			],
		}
	},
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		swiperOption() {
			return {
				slidesPerView: this.userDevice === 'desktop' ? 4 : 1.2,
				spaceBetween: 10,
				centeredSlides: this.userDevice === 'desktop' ? false : true,
				loop: true,
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
			}
			// autoplay: {
			// 	delay: 1500,
			// 	disableOnInteraction: false,
			// },
			// breakpoints: {
			// 	1600: {
			// 		slidesPerView: 5,
			// 		spaceBetween: 10,
			// 	},
			// 	1400: {
			// 		slidesPerView: 4,
			// 		spaceBetween: 10,
			// 	},
			// 	900: {
			// 		slidesPerView: 3,
			// 		spaceBetween: 10,
			// 	},
			// 	700: {
			// 		slidesPerView: 2.5,
			// 		spaceBetween: 10,
			// 	},
			// 	600: {
			// 		slidesPerView: 2,
			// 		spaceBetween: 10,
			// 	},
			// 	500: {
			// 		slidesPerView: 1.5,
			// 		spaceBetween: 10,
			// 	},
			// 	400: {
			// 		slidesPerView: 1.2,
			// 		spaceBetween: 10,
			// 	},
			// },
			// loop: true,
		},
	},
	created() {
		setInterval(() => {
			this.slide++
			if (this.slide >= 5) this.slide = this.slide - 5
		}, 1000)
	},
}
</script>

<style lang="scss" scoped>
.gradient {
	width: 27%;
	height: 235px;
	position: absolute;
	z-index: 2;
	top: 0;
}
.gradient.left {
	background-image: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
}
.gradient.right {
	right: 0;
	background-image: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));
}
</style>
